export const API_BASE_URL = process.env.REACT_APP_REST_API_BASE_URL;
